'use client'
import PrivacyPolicy from '@/components/page-partials/privacy-policy'

const Page = () => {
  return <PrivacyPolicy />
}

export default Page
